<form [formGroup]="emailFormGroup">


  <div class="card bg-white shadow-item list-data text-center mg-btm-30 ">
    <div class="card-title-top-sub">
      <h1 class="color-blue-dark font-30">
          Tu {{tipoDocumento.trabajador}} se ha generado
      </h1>
    </div>
    
    
    <div class="col-xs-12">
      <div class="icon-living-place shadow-item">
        <em class="material-icons icon-head">
          <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32.5" cy="32.5" r="32.5"/>
            <circle cx="33" cy="33" r="28" fill="#0067B1"/>
            <path d="M43 33H37L35 36H31L29 33H23" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.45 26.11L23 33V39C23 40.1046 23.8954 41 25 41H41C42.1046 41 43 40.1046 43 39V33L39.55 26.11C39.2123 25.4303 38.5189 25.0004 37.76 25H28.24C27.4811 25.0004 26.7877 25.4303 26.45 26.11Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </em>
      </div>
      <div class="header-card d-flex justify-content-center text-center">
        <h2 class="header-card_title u-medium mg-btm-20 f-16 title-card-option">Imprime, descarga o envía el documento a tu correo electrónico</h2>
      </div>
    </div>

    <ul class="list-data ">
      <li class="d-flex middle-xs wow fadeInDown text-center justify-content-center cards-grid">
        
        <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3 pdd-x-5">
          <div class="action-tile" role="button" tabindex="0" [class.disabled]="downloading"
            (click)="!downloading && printAffiliation()" [attr.aria-label]="'Descargar documento PDF'"> 
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15" stroke="#0067B1"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7 10L12 15L17 10" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12 15V3" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="action-title">
              {{ downloading ? 'Descargando...' : 'Descargar' }}
            </div>
 
            <div class="action-subtitle">
              Documento PDF
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-lg-3 col-md-3 pdd-x-5">
          <div class="action-tile" role="button" tabindex="0" [class.disabled]="printing"
            (click)="!printing && printAffiliationWindow()" [attr.aria-label]="'Imprimir vista previa'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M14 2V8H20" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M16 13H8" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M16 17H8" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M10 9H9H8" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg> 
            <div class="action-title">
              {{ printing ? 'Procesando...' : 'Imprimir' }}
            </div>
 
            <div class="action-subtitle">
              Vista previa
            </div>
          </div>
        </div>
        
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 pdd-x-5"> 
          <div class="send-container">
 
            
            <div class="send-header">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                  stroke="#0067B1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22 6L12 13L2 6" stroke="#0067B1" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <span class="action-title">Enviar al correo</span>
            </div>
 
            <div class="send-label">
              Correo electrónico
            </div>
 
            
            <div class="send-row">
 
              
              <div class="send-form">
                <input type="text" class="input--regular download-input-1" placeholder="Ingresa tu correo" id="email"
                  required formControlName="email" aria-label="Escribir el correo electrónico" (blur)="onEmailBlur()"
                  (input)="onEmailInput()" maxlength="49" [(ngModel)]="sendEmail" 
                  pattern="^[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,5}$"
                  [ngClass]="{ 'input-error': emailInvalido }" />
 
                <p class="email-error-message" *ngIf="emailInvalido">
                  El correo no es válido
                </p>
              </div>
 
              <div class="send-action">
                <button appDebounceClick 
                  id="Descarga_PTPC-Certificado Afiliación trabajadores" [label]="'Enviar por correo'" title="Email"
                  class="u-btn--light u-btn u-btn--yellow u-btn--small download-button-1" (click)="affiliationGenerate()"
                  [disabled]="!emailFormGroup.valid || emailInvalido || sending" aria-label="Enviar">
                  {{ sending ? 'Enviando...' : 'Enviar' }}
                </button>
              </div>
 
            </div>
          </div>
        </div>

      </li>
    </ul>
  </div>
</form>

<div class="col-xs-12">
  <div class="pad-sm-none d-flex justify-content-center text-center">
    

    <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 p-0">
      <a
      appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Volver al inicio"
      [routerLink]="home" class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon mg-btm-30 nav-bottom-btn">
        Volver al inicio
      </a>
    </div>

    <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 p-0">
      <a
      appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Cargar otro afiliado"
      [routerLink]="afiliacion" class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon mg-btm-30 nav-bottom-btn">
        Generar nuevo documento
      </a>
    </div>
  </div>
</div>


<div  class="modal-backdrop"  *ngIf="modalOpen"  (click)="closeModal()"  aria-hidden="true">
  <div    class="modal-card" role="dialog" aria-modal="true" aria-labelledby="modalTitle" aria-describedby="modalDesc" (click)="$event.stopPropagation()" >    
    
    <button type="button" class="modal-close" aria-label="Cerrar" (click)="closeModal()" > × </button>

    
    <div class="modal-icon" [ngClass]="{ 'is-success': modalType === 'success', 'is-error': modalType === 'error' }">
      
      
      <ng-container *ngIf="modalType === 'success'">
        <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M43.5549 7.49938C43.8181 7.6881 44.0813 7.87683 44.3301 8.07878" stroke="#0067B1" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M50.4612 14.2527C51.7931 16.3601 52.8144 18.6484 53.4936 21.047C56.6729 32.1892 52.1697 44.0981 42.4132 50.3497C32.6567 56.6012 19.9552 55.7165 11.1602 48.1727C2.36523 40.6288 -0.442422 28.2108 4.25177 17.617C8.94597 7.02322 20.0314 0.760248 31.5283 2.20642" stroke="#0067B1" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M28.2495 16.2499C21.6219 16.2499 16.2495 21.6223 16.2495 28.2499C16.2495 34.8775 21.6219 40.2499 28.2495 40.2499C34.8771 40.2499 40.2495 34.8775 40.2495 28.2499C40.2495 21.6223 34.8771 16.2499 28.2495 16.2499ZM35.098 25.4982L26.698 33.8982C26.464 34.1322 26.1568 34.2498 25.8496 34.2498C25.5424 34.2498 25.2352 34.1322 25.0012 33.8982L21.4012 30.2982C20.932 29.829 20.932 29.0706 21.4012 28.6014C21.8704 28.1322 22.6288 28.1322 23.098 28.6014L25.8496 31.353L33.4012 23.8014C33.8704 23.3322 34.6288 23.3322 35.098 23.8014C35.5672 24.2706 35.5672 25.029 35.098 25.4982Z" fill="#2E7D32"/>
        </svg>
      </ng-container>

      
      <ng-container *ngIf="modalType === 'error'">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21 38.5C30.665 38.5 38.5 30.665 38.5 21C38.5 11.335 30.665 3.5 21 3.5C11.335 3.5 3.5 11.335 3.5 21C3.5 30.665 11.335 38.5 21 38.5Z" fill="#D32F2F" stroke="#D32F2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M26.25 15.75L15.75 26.25" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M15.75 15.75L26.25 26.25" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </ng-container>

    </div>

    <div id="modalTitle" class="modal-title">
      {{ modalTitle }}
    </div>

    <div id="modalDesc" class="modal-desc">
      {{ modalMessage }}
    </div>

    <button type="button" class="modal-action" (click)="closeModal()">
      Aceptar
    </button>
  </div>
</div>
